/**
 * @graphql cc
 */
import gql from 'graphql-tag';
import {
	// eslint-disable-next-line graphql-relay-compat/no-import-apollo-functions -- Read http://go/cfe-no-import-apollo-functions
	useQuery,
} from '@apollo/react-hooks';

import { useViewUserProfile } from '@confluence/global-operations/entry-points/useViewUserProfile.ts';

import type {
	useProfileInfoUserContextQuery as useProfileInfoUserContextQuery$data,
	useProfileInfoUserContextQueryVariables as useProfileInfoUserContextQuery$variables,
} from './__types__/useProfileInfoUserContextQuery.ts';

// Hook which returns info needed for the profile macros
export const useProfileInfo = (userId?: string) => {
	const { canViewUserProfile: hasViewUserProfilePermission } = useViewUserProfile();

	const { data, error } = useQuery<
		useProfileInfoUserContextQuery$data,
		useProfileInfoUserContextQuery$variables
	>(
		gql`
			query useProfileInfoUserContextQuery($userId: ID) {
				user: confluence_atlassianUser(id: $userId) {
					id
					photos {
						value
						isPrimary
					}
					displayName
					emails {
						value
						isPrimary
					}
					title
					isActive
				}
			}
		`,
		{
			variables: {
				userId,
			},
			skip: !userId,
		},
	);

	return {
		graphqlError: error,
		hasViewUserProfilePermission,
		userName: data?.user?.displayName ?? '',
		iconUrl: data?.user?.photos?.[0]?.value ?? '',
		email: hasViewUserProfilePermission ? (data?.user?.emails?.[0]?.value ?? '') : '',
		jobTitle: data?.user?.title ?? '',
		isActiveUser: data?.user?.isActive ?? true,
	};
};
